<script setup lang="ts">
/**
 * Marketing frame: header, full-width bands, footer, chat widget. No back
 * link; these pages are entry points.
 */
defineProps({
  showBackButton: {
    type: Boolean,
    default: false
  }
})
</script>

<template>
  <div class="sofax flex min-h-screen flex-col bg-white dark:bg-gray-950">
    <AppNavbar />

    <main class="grow">
      <slot />
    </main>

    <AppFooter />
    <LazyIdleCommonChatWidget hydrate-on-idle />
  </div>
</template>
